/**
 * WhiteboardContainer: 화이트보드 Redux 연결 컴포넌트
 * v1 원본: utils/whiteboard/WhiteboardContainer.js (50줄)
 * v2 변환: hooks 패턴 (connect → useAppSelector + useWhiteboard)
 *
 * 역할:
 * - useWhiteboard 훅으로 전체 화이트보드 상태 관리
 * - 유효하지 않으면 null 반환
 * - WhiteboardPresenter에 모든 props 전달
 */
import React from 'react';
import { useWhiteboard } from '@/hooks/useWhiteboard';
import WhiteboardPresenter from './WhiteboardPresenter';

interface WhiteboardContainerProps {
  /** 읽기전용 모드 (GRID 서브뷰에서 true) */
  isViewOnly?: boolean;
  /** 서브 비디오(미니) 모드 */
  isSubVideoMode?: boolean;
}

const WhiteboardContainer: React.FC<WhiteboardContainerProps> = ({
  isViewOnly = false,
  isSubVideoMode = false,
}) => {
  const whiteboardState = useWhiteboard({
    isViewOnly,
    isSubVideoMode,
  });

  if (!whiteboardState.isValid || !whiteboardState.roomId || !whiteboardState.roomKey) {
    return null;
  }

  return (
    <WhiteboardPresenter
      {...whiteboardState}
      isSubVideoMode={isSubVideoMode}
    />
  );
};

export default WhiteboardContainer;
